import apiCore from '../../utils/api-core';

export default {
	getTemplates() {
		return apiCore.get('/api/v1/templates');
	},

	createTemplate(body) {
		return apiCore.post('/api/v1/templates', body);
	},

	updateTemplate(id, body) {
		return apiCore.put(`/api/v1/templates/${id}`, body);
	},
	
	deleteTemplate(id) {
		return apiCore.delete(`/api/v1/templates/${id}`);
	}
};
